<template>
    <router-view :groupcode="groupcode"></router-view>
</template>

<script>
    export default {
        name: 'Enrollment',
        props: ['groupcode'],
    }
</script>

<style scoped>

</style>
